// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.star-rating {
  display: inline-flex;
  align-items: center;
  line-height: 0;
}

.star-rating-glyph {
  width: 2rem;
  height: 2rem;
  margin: 0 0.1rem;
  display: block;
  /* Lecture seule : les etoiles du calque plein doivent etre DECOUPEES par
     overflow:hidden, pas compressees par le flex -> on bloque le shrink. */
  flex-shrink: 0;
}

.star-rating-glyph path {
  fill: #d1d5db;
  transition: fill 0.12s ease;
}

.star-rating-glyph.is-filled path {
  fill: #f97316;
}

/* Lecture seule : superposition d'un calque plein decoupe a la largeur = moyenne. */
.star-rating-track {
  position: relative;
  display: inline-flex;
}

.star-rating-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  overflow: hidden;
  display: inline-flex;
  flex-wrap: nowrap;
  pointer-events: none;
}

/* Interactif : boutons cliquables. */
.star-rating-btn {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  line-height: 0;
}

.star-rating-btn:focus-visible {
  outline: 2px solid #f97316;
  outline-offset: 2px;
  border-radius: 4px;
}

.star-rating--interactive .star-rating-glyph {
  transition: transform 0.08s ease, fill 0.12s ease;
}

.star-rating-btn:hover .star-rating-glyph {
  transform: scale(1.12);
}

/* Skeleton de chargement : etoiles grises qui pulsent. */
.star-rating--skeleton {
  animation: star-rating-skeleton-pulse 1.4s ease-in-out infinite;
}

.star-rating--skeleton .star-rating-glyph path {
  fill: #e5e7eb;
}

@keyframes star-rating-skeleton-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.45;
  }
}
`, "",{"version":3,"sources":["webpack://./src/composants/StarRating/StarRating.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd;2EACyE;EACzE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA,oFAAoF;AACpF;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;AACxB;;AAEA,yDAAyD;AACzD;EACE,+DAA+D;AACjE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".star-rating {\n  display: inline-flex;\n  align-items: center;\n  line-height: 0;\n}\n\n.star-rating-glyph {\n  width: 2rem;\n  height: 2rem;\n  margin: 0 0.1rem;\n  display: block;\n  /* Lecture seule : les etoiles du calque plein doivent etre DECOUPEES par\n     overflow:hidden, pas compressees par le flex -> on bloque le shrink. */\n  flex-shrink: 0;\n}\n\n.star-rating-glyph path {\n  fill: #d1d5db;\n  transition: fill 0.12s ease;\n}\n\n.star-rating-glyph.is-filled path {\n  fill: #f97316;\n}\n\n/* Lecture seule : superposition d'un calque plein decoupe a la largeur = moyenne. */\n.star-rating-track {\n  position: relative;\n  display: inline-flex;\n}\n\n.star-rating-fill {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  overflow: hidden;\n  display: inline-flex;\n  flex-wrap: nowrap;\n  pointer-events: none;\n}\n\n/* Interactif : boutons cliquables. */\n.star-rating-btn {\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  line-height: 0;\n}\n\n.star-rating-btn:focus-visible {\n  outline: 2px solid #f97316;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.star-rating--interactive .star-rating-glyph {\n  transition: transform 0.08s ease, fill 0.12s ease;\n}\n\n.star-rating-btn:hover .star-rating-glyph {\n  transform: scale(1.12);\n}\n\n/* Skeleton de chargement : etoiles grises qui pulsent. */\n.star-rating--skeleton {\n  animation: star-rating-skeleton-pulse 1.4s ease-in-out infinite;\n}\n\n.star-rating--skeleton .star-rating-glyph path {\n  fill: #e5e7eb;\n}\n\n@keyframes star-rating-skeleton-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.45;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
